import { render } from "./header.vue?vue&type=template&id=d88f2960&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=d88f2960&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d88f2960"

export default script